import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_SUPERVISORS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={CFRD_SUPERVISORS} id={id} />;
}

export const Route = createFileRoute("/_app/cfrd/supervisors/$id")({
  component: Edit,
});
